import { gql } from '@apollo/client';

const CREATE_ORDERSTATUS_MUTATION = gql`
  mutation CreateOrderStatus($publisherId: Int!, $value: String!) {
    createOrderStatus(publisherId: $publisherId, value: $value) {
      orderStatus {
        id
        value
      }
    }
  }
`;

export default CREATE_ORDERSTATUS_MUTATION;
